export default __webpack_public_path__ + "static/media/regulatory--end-of-no-parking-or-stopping--g1.9448279b.png";